import { DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonPrimaryComponent } from 'projects/components/button-primary/button-primary.component';

@Component({
  selector: 'pay-login-remember-me-info-popup',
  imports: [TranslatePipe, ButtonPrimaryComponent],
  templateUrl: './remember-me-info-popup.html',
  styles: '',
})
export class RememberMeInfoPopup {
  readonly dialog = inject(DialogRef);

  protected close() {
    this.dialog.close();
  }
}
